import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import SyncForm from './components/SyncForm';
import SyncMonitor from './components/SyncMonitor';
import LogViewer from './components/LogViewer';
import './App.css';

function App() {
  const [socket, setSocket] = useState(null);
  const [currentView, setCurrentView] = useState('form'); // 'form', 'sync', 'logs'
  const [syncData, setSyncData] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    // Get or create user ID from localStorage
    let storedUserId = localStorage.getItem('imapsync-user-id');
    if (!storedUserId) {
      storedUserId = 'user-' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('imapsync-user-id', storedUserId);
    }

    // Initialize WebSocket connection with user ID
    const newSocket = io(window.location.origin, {
      transports: ['websocket', 'polling'],
      query: { userId: storedUserId }
    });

    newSocket.on('connect', () => {
      console.log('Connected to server');
      setIsConnected(true);
    });

    newSocket.on('disconnect', () => {
      console.log('Disconnected from server');
      setIsConnected(false);
    });

    newSocket.on('user-session', (data) => {
      console.log('User session established:', data.userId);
      setUserId(data.userId);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  const handleStartSync = (config) => {
    if (socket) {
      setSyncData({ config, logs: [], stats: {}, status: 'starting' });
      setCurrentView('sync');
      socket.emit('start-sync', config);
    }
  };

  const handleBackToForm = () => {
    setCurrentView('form');
    setSyncData(null);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'sync':
        return (
          <SyncMonitor
            socket={socket}
            syncData={syncData}
            setSyncData={setSyncData}
            onBack={handleBackToForm}
          />
        );
      case 'logs':
        return (
          <LogViewer
            socket={socket}
            onBack={() => setCurrentView('form')}
          />
        );
      default:
        return (
          <SyncForm
            onStartSync={handleStartSync}
            onViewLogs={() => setCurrentView('logs')}
          />
        );
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <h1>🔄 ImapSync Online</h1>
          <div className="connection-status">
            <span className={`status-dot ${isConnected ? 'connected' : 'disconnected'}`}></span>
            {isConnected ? 'Connected' : 'Disconnected'}
          </div>
        </div>
      </header>

      <main className="app-main">
        {renderCurrentView()}
      </main>

      <footer className="app-footer">
        <p>
          Powered by ImapSync • Real-time WebSocket monitoring •{' '}
          <a
            href="https://github.com/Mythfinity/imapsync-ini-wrapper"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-source-link"
          >
            Source code
          </a>{' '}
          (AGPL-3.0)
        </p>
      </footer>
    </div>
  );
}

export default App;